import announcementsService from '../services/announcementsService';

export const fetchAnnouncements = async (params) => {
  const result = await announcementsService.getAllAnnouncements(params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Duyurular alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const fetchAnnouncementById = async (id) => {
  const result = await announcementsService.getAnnouncementById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Duyuru alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const createAnnouncement = async (payload, coverImage, attachments) => {
  const result = await announcementsService.createAnnouncement(payload, coverImage, attachments);
  if (!result?.success) {
    const error = new Error(result?.message || 'Duyuru oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateAnnouncement = async (payload) => {
  const result = await announcementsService.updateAnnouncement(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Duyuru güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const deleteAnnouncement = async (id) => {
  const result = await announcementsService.deleteAnnouncement(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Duyuru silinemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const publishAnnouncement = async (id) => {
  const result = await announcementsService.publishAnnouncement(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Duyuru yayınlanamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateAnnouncementCoverImage = async (id, coverImage) => {
  const result = await announcementsService.updateCoverImage(id, coverImage);
  if (!result?.success) {
    const error = new Error(result?.message || 'Kapak görseli güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateAnnouncementAttachments = async (id, keepAttachmentUrls, newFiles) => {
  const result = await announcementsService.updateAttachments(id, keepAttachmentUrls, newFiles);
  if (!result?.success) {
    const error = new Error(result?.message || 'Ek dosyalar güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export default {
  fetchAnnouncements,
  fetchAnnouncementById,
  createAnnouncement,
  updateAnnouncement,
  deleteAnnouncement,
  publishAnnouncement,
  updateAnnouncementCoverImage,
  updateAnnouncementAttachments,
};



